import { StateCreator } from "zustand";
import { produce } from "immer";
import { toast } from "react-toastify";
import { downloadURI } from "../../utils/functions/download";
import moment from "moment";
import { useStore } from "../useStore";
import { ImportState, ImportType } from "../types/import";
import importService from "../../services/importService";

export const importFileStrategy = new Map([
  [
    ImportType.IMPORT_MACROS,
    'importBatchMacros',
  ],
]);

export const createImportSlice: StateCreator<ImportState> = (
  set
) => ({
  import: {
    isUploadingFile: false,
    importType: null,
    setImportType: (importType: ImportType) => {
      set(
        produce((state) => {
          state.import.importType = importType;
        })
      );
    },
    importFile: (file: any) => {
      set(
        produce((state) => {
          state.import.isUploadingFile = true;
        })
      );
      importService.importFile({ 
        file
      }).then((data: any) => {
          toast.success(data.data.data.response_message);
          useStore.getState().modal.clearModals();
        })
        .catch((error: any) => {
          console.log(error);
          toast.error(error.message);
        })
        .finally(() => {
          set(
            produce((state) => {
              state.import.isUploadingFile = false;
            })
          );
        });
    }
  },
});
